import { graphql } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../layouts/default";
import KaramoHero from "../sections/KaramoHero";
import KaramoProducts from "../sections/KaramoProducts";
import KaramoVideo from "../sections/KaramoVideo";

export const query = graphql`
  {
    contentfulKaramoLandingPage {
      heroHeadline
      heroIntro {
        raw
      }
      heroText {
        raw
      }
      heroBackground {
        fluid(maxWidth: 1440, quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      journeyVideoYoutubeId
      videoPlaceholder {
        fluid(maxWidth: 1440, quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      favoritesFeaturedProduct {
        description {
          raw
        }
        product {
          ... on ContentfulProduct {
            __typename
            id
            name
            variants {
              volumeOrSize
              subscription {
                shopifyId
                price
              }
              individual {
                shopifyId
                price
              }
            }
            slug
          }
          ... on ContentfulProductSet {
            __typename
            id
            name
            variants {
              volumeOrSize
              subscription {
                shopifyId
                price
              }
              individual {
                shopifyId
                price
              }
            }
            slug
          }
        }
        image {
          fluid(maxWidth: 1440, quality: 100) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
      }
      favoritesOtherProducts {
        description {
          raw
        }
        image {
          fluid(maxWidth: 1440, quality: 100) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        product {
          ... on ContentfulProduct {
            __typename
            id
            name
            variants {
              volumeOrSize
              subscription {
                shopifyId
                price
              }
              individual {
                shopifyId
                price
              }
            }
            slug
          }
          ... on ContentfulProductSet {
            __typename
            id
            name
            variants {
              volumeOrSize
              subscription {
                shopifyId
                price
              }
              individual {
                shopifyId
                price
              }
            }
            slug
          }
        }
      }
    }
  }
`;

export default function KaramosStory({ data, location }) {
  const content = data.contentfulKaramoLandingPage;

  if (process.env.GATSBY_LOCALE === "en-GB") {
    return null;
  }

  return (
    <Layout pathName={location.pathname}>
      <Helmet>
        <title>Karamo's Story</title>
      </Helmet>
      <KaramoHero
        headline={content.heroHeadline}
        image={content.heroBackground}
        intro={content.heroIntro}
        text={content.heroText}
      />
      <KaramoProducts
        featuredProduct={content.favoritesFeaturedProduct}
        otherProducts={content.favoritesOtherProducts}
      />
      <KaramoVideo
        id={content.journeyVideoYoutubeId}
        placeholder={content.videoPlaceholder}
      />
    </Layout>
  );
}
